const PreviousReports = {
    "ReportOneTitle":"Cyber Security and Its Impact on Digital Saudi",
    "ReportTwoTitle":"A Digital Government Vision for the Kingdom of Saudi Arabia",
    "ReportThreeTitle":"Envisioning an ICT led Approach to the “National Transformation Program” for the Kingdom of Saudi Arabia",
    "ReportFourTitle":`Realizing Saudi Arabia’s Digital Aspirations: The Journey of Transformation`
}


export {PreviousReports};